/* stylelint-disable no-descending-specificity */
import styled from 'styled-components';
import { colors } from '@a0/quantum-web';

export const Wrapper = styled.section`
  padding: 0.4rem;
  background: #000;
  border-radius: 2.4rem;
  max-width: 93.2rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.075),
    0 1.2rem 1.2rem rgba(0, 0, 0, 0.1);
`;

export const Title = styled.p`
  font-family: 'SpaceGrotesk', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.8rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  color: #f1f3f7;
  padding-bottom: 1.6rem;
  margin: 0 0 3.2rem;
  border-bottom: 0.1rem solid #3a3e44;
`;

export const DarkContainer = styled.div`
  padding: 3.2rem 6rem 3.2rem 6.4rem;
  min-width: 54rem;
`;

export const LinksWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2.4rem 3.2rem;
`;

export const GreyContainer = styled.div`
  padding: 3.2rem 6.4rem;
  background: #1e212a;
  border-radius: 2.2rem;
  width: 100%;
`;

export const DarkLink = styled.a`
  text-decoration: none;

  p {
    margin: 0;
    transition: all 0.2s ease;
  }

  p:first-child {
    color: ${colors.neutral_n20};
    position: relative;
    display: inline-block;
    :after {
      transition: all 0.2s ease;
      opacity: 0;
      content: '→';
      padding-left: 0.5rem;
      position: absolute;
      right: -2rem;
    }
  }

  p:nth-child(2) {
    color: ${colors.neutral_n60};
  }

  :hover {
    p:first-child {
      color: ${colors.neutral_n20};
      :after {
        opacity: 1;
      }
    }
    p:nth-child(2) {
      color: ${colors.neutral_white};
    }
  }
`;

export const GreyLink = styled(DarkLink)`
  p:nth-child(2) {
    color: ${colors.neutral_n20};
    position: relative;
    display: inline-block;
    :after {
      transition: all 0.2s ease;
      opacity: 0;
      content: '→';
      padding-left: 0.5rem;
      position: absolute;
      right: -2rem;
    }
  }

  p:nth-child(3) {
    color: ${colors.neutral_n60};
  }

  :hover {
    p:nth-child(2) {
      color: ${colors.neutral_n20};
      :after {
        opacity: 1;
      }
    }

    p:nth-child(3) {
      color: ${colors.neutral_white};
    }
  }
`;

export const ImageWrapper = styled.div`
  margin-bottom: 2.2rem;
  img {
    object-fit: cover;
    border-radius: 1.6rem;
  }
`;
